export default __webpack_public_path__ + "static/media/interview-user-journeys.32303a5f.svg";